// extracted by mini-css-extract-plugin
export var actionButton = "_7r-1";
export var actionButtons = "_7r-2";
export var actions = "_7r-0";
export var aiUnread = "_7r-10";
export var alignCenter = "_7r-h";
export var backWrapper = "_7r-3";
export var cellContainer = "_7r-4";
export var checkboxContainer = "_7r-5";
export var contentContainer = "_7r-6";
export var contentHeader = "_7r-8";
export var conversationsTableWrapper = "_7r-s";
export var draftReplyBadgeContainer = "_7r-m";
export var dropdownItem = "_7r-b";
export var dropdownItemsContainer = "_7r-a";
export var dropdownTitle = "_7r-c";
export var errorIcon = "_7r-7";
export var filter = "_7r-d";
export var gray = "_7r-i";
export var headerActionButtons = "_7r-e";
export var headerCheckboxContainer = "_7r-f";
export var icon = "_7r-j";
export var menuContainer = "_7r-k";
export var noMoreTicketsIcon = "_7r-12";
export var noMoreTicketsSubText = "_7r-13";
export var oneLine = "_7r-l";
export var optionsButton = "_7r-n";
export var plus = "_7r-o";
export var portalButtonsWrapper = "_7r-g";
export var red = "_7r-p";
export var scrolledTop = "_7r-9";
export var search = "_7r-q";
export var selectedConversationsCount = "_7r-r";
export var spinner = "_7r-t";
export var strong = "_7r-u";
export var summaryCell = "_7r-v";
export var tableContainer = "_7r-11";
export var tagContainer = "_7r-w";
export var threeDots = "_7r-x";
export var twoLines = "_7r-y";
export var unread = "_7r-z";